import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import CustomInput from "../TextField/TextFeild";
import { ModifyStationGroup } from '../../store/slices/invitesSlice';

const StationGroupPopup = ({ show, onClose, row }) => {
  const dispatch = useDispatch();

  const validationSchema = Yup.object({
    stationGroup: Yup.string().required("StationGroup is required"),
  });

  const formik = useFormik({
    initialValues: {
      stationGroup: '',
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      const { stationGroup } = values;
      dispatch(
        ModifyStationGroup({
          message: 'Status Updated.',
          payload: {
            id: row.attributes.id,
            type: 'user',
            attributes: {
              stationGroup
            },
          },
        })
      ).unwrap().then(() => {
        onClose();
        resetForm();
      });


    }
  });

  useEffect(() => {
    if (row) {
      const metaData = row.attributes?.metadata;
      formik.setValues({
        stationGroup: metaData.stationGroup || '',
      });
    }
  }, [row, show]);

  return (
    <Modal show={show} onHide={onClose} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>Modify Station Group</Modal.Title>
      </Modal.Header>
      <form className="" onSubmit={formik.handleSubmit}>
        <div className="form-card shadow-none">
          <div className="">
             <CustomInput
              label="Station Group"
              id="stationGroup"
              name="stationGroup"
              value={formik.values.stationGroup}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.stationGroup && formik.errors.stationGroup}
              required
            />
          </div>
          <div className="text-right px-3 pt-3">
            <div className="button-div">
              <button
                type="submit"
                className="btn btn-outline-danger mx-3"
                disabled={formik.isSubmitting}
                onClick={onClose}
              >
                <span>Cancel</span>
              </button>
              <button
                type="submit"
                className="btn btn-secondary"
                disabled={formik.isSubmitting}
              >
                <span>{formik.isSubmitting ? "Updating..." : "Update"}</span>
              </button>
            </div>
          </div>
        </div>


      </form>
    </Modal>
  );
};

export default StationGroupPopup;
